import getIn from 'transmute/getIn';
export const getIsUngatedForChatTransfer = state => {
  return getIn(['widgetData', 'data', 'gates'], state).get('Conversations:TransferState');
};